import { UntypedFormControl } from '@angular/forms';
import { splitMultipleEmails } from './email-helper';
import { emailPattern } from './email-validator';

export function multiValidateEmail(control: UntypedFormControl): { [key: string]: any } {
  if (control.value) {
    const mails = splitMultipleEmails(String(control.value));
    const everyMailCorrect = mails.every(mail => {
      return emailPattern.test(mail);
    });
    if (!everyMailCorrect) {
      return { validateEmail: { valid: false } };
    }
  }
  return null;
}
